import { render, staticRenderFns } from "./PropEdit.vue?vue&type=template&id=46acb2f7&scoped=true&"
import script from "./PropEdit.vue?vue&type=script&lang=js&"
export * from "./PropEdit.vue?vue&type=script&lang=js&"
import style0 from "./PropEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PropEdit.vue?vue&type=style&index=1&id=46acb2f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46acb2f7",
  null
  
)

component.options.__file = "www/vues/common/editor/PropEdit.vue"
export default component.exports